import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const PosVendaDashboard = lazy(() => import('./Dashboard'));
const PosVendaMeuPainel = lazy(() => import('./MeuPainel'));
const PosVendaRespostas = lazy(() => import('./Respostas'));
const PosVendaAtendentes = lazy(() => import('./Atendentes'));
const PesquisaPublica = lazy(() => import('../Publico/PesquisaPublica'));

export const posVendaRoutes: (RouteObject & { layout?: string })[] = [
    {
        path: '/pos-venda',
        element: (
            <ProtectedRoute anyOf={['posvenda.admin', 'posvenda.view', 'posvenda.atendente']}>
                <PosVendaDashboard />
            </ProtectedRoute>
        ),
    },
    {
        path: '/pos-venda/meu-painel',
        element: (
            <ProtectedRoute permission="posvenda.atendente">
                <PosVendaMeuPainel />
            </ProtectedRoute>
        ),
    },
    {
        path: '/pos-venda/respostas',
        element: (
            <ProtectedRoute anyOf={['posvenda.admin', 'posvenda.view', 'posvenda.atendente']}>
                <PosVendaRespostas />
            </ProtectedRoute>
        ),
    },
    {
        path: '/pos-venda/atendentes',
        element: (
            <ProtectedRoute permission="posvenda.admin">
                <PosVendaAtendentes />
            </ProtectedRoute>
        ),
    },
    // Página pública: o cliente chega pelo QR do atendente. Sem login, sem layout do portal.
    {
        path: '/p/:token',
        element: <PesquisaPublica />,
        layout: 'blank',
    },
];
